export default "__VITE_PUBLIC_ASSET__557ea6bd__"